var _title, _desc, _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgElectricitySale = function SvgElectricitySale(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "268F1B5E-33C1-463A-869E-4E6F88537CFA")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ele-sale",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ele-sale",
    transform: "translate(-51.000000, -117.000000)",
    fill: "#006633",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4991674,119.000641 C60.3679337,118.992271 60.2432846,119.066359 60.1748543,119.193404 L55.1069942,125.777023 C55.0397641,125.864105 55.0018699,125.975275 55,126.09091 C55,126.417051 55.3097419,126.681923 55.6923397,126.681923 L59.1532057,126.681923 L58.1540383,131.704118 C58.1540383,131.867188 58.3089092,131.999624 58.5,131.999624 C58.6194678,132.005335 58.7340844,131.945718 58.8080766,131.839381 L63.9054954,125.205804 C63.9650424,125.121873 63.9982833,125.017932 64,124.910298 C64,124.584157 63.6902581,124.319285 63.3076603,124.319285 L59.8455454,124.319285 L60.8447127,119.29709 C60.8455454,119.133077 60.6902581,119.000641 60.4991674,119.000641 Z",
    id: "ico/bolt/green"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElectricitySale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/electricity-sale.82cbe08e.svg";
export { ForwardRef as ReactComponent };